import React from 'react';
import { withRouter } from 'react-router-dom'
import { Form, Input, Button, Checkbox } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import './LoginForm.less'
import API from '@/api'
import { connect } from 'react-redux'
import { setUser } from '@/store/actions'
import cryptoData from '@/lib/cryptoData'
import Storage from '@/lib/storage'

@withRouter
@connect(
  state => ({ user: state.user }),
  { setUser }
)
class LoginForm extends React.Component {
  constructor (props) {
    super(props)
  }

  onFinish = async values => {
    if (!this.state.publicKey) throw 'publicKey 获取失败'
    console.log('Received values of form: ', values);

    const data = {
      account: values.username,
      password: values.password
    }

    const text = cryptoData.publicEncrypt(data, this.state.publicKey, 'base64')
    const loginRes = await API.Login({
      login_data: text
    })
    if (loginRes.code === 200) {
      const loginResultBuffer = loginRes.result.login_result

      const lg = cryptoData.publicDecrypt(this.state.publicKey, Buffer.from(loginResultBuffer, 'base64'))
      Storage.set('GG_PRO_USER', lg, 2 * 3600 * 1000)
      this.props.setUser(lg)

      this.props.history.push('/admin')
    }
  };

  async componentDidMount() {
    const cert = await API.LoginCert()
    if (cert.code !== 200) return
    this.setState({
      publicKey: cert.result.publicKey
    })
  }

  async componentWillUnmount () {
    this.setState = () => false;
  }

  render () {
    const { onFinish } = this

    return (
      <Form
        name="normal_login"
        className="login-form"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
      >
        <Form.Item
          name="username"
          rules={[
            {
              required: true,
              message: '请输入登录名!',
            },
          ]}
        >
          <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: '请输入登陆密码!',
            },
          ]}
        >
          <Input
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Password"
          />
        </Form.Item>
        <Form.Item>
          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox>Remember me</Checkbox>
          </Form.Item>
  
          <a className="login-form-forgot" href="">
            Forgot password
          </a>
        </Form.Item>
  
        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button">
            Log in
          </Button>
          Or <a href="">register now!</a>
        </Form.Item>
      </Form>
    );
  }
}

export default LoginForm
